import { lazy } from 'react';

export const EvaluationReportRoutes = [
    {
        // label: '',
        // key: 'EvaluationReport',
        // show: false,
        // path: '/evaluationReport/:id',
        // element: lazy(() => import('src/components/Layout/CommonLayout')),
        // children: [
        //     {
        //         label: '测评报告',
        //         key: 'evaluation-report',
        //         show: false,
        //         path: '/evaluationReport/:id',
        //         element: lazy(() => import('@/page/EvaluationReport'))
        //     }
        // ]
        label: '测评报告',
        key: 'evaluation-report',
        show: false,
        path: '/evaluationReport/:id',
        element: lazy(() => import('@/page/EvaluationReport'))
    },
    {
        label: '',
        key: 'mind-map',
        show: false,
        path: '/mindMap/:id',
        element: lazy(() => import('src/components/Layout/CommonLayout')),
        children: [
            {
                label: '思维导图',
                key: 'mind-map',
                show: false,
                path: '/mindMap/:id',
                element: lazy(() => import('@/page/MindMap'))
            }
        ]
    }
];
